import { getUploadProjectSchemes } from 'store/actions';
import * as actionTypes from '../actions/actionTypes';
import { updateObject } from '../utility';

const initialState = {
    projects: {},
    activeProject: null,
    order: [],
    error: null,
    loading: false,
    deletedLoading: false,
    uploadProjectSchemes: [],
    schemesLoading: false,
    schemesError: null,
    currentProject: {}
};

const getUploadProjectsStart = (state, action) => {
    return updateObject(state, { error: null, loading: true });
}

const getUploadProjectsFail = (state, action) => {
    return updateObject(state, {
        error: action.error,
        loading: false
    });
}

const getUploadProjectsSuccess = (state, action) => {
    let newProjects = {},
        members,
        project;
    Object.keys(action.projects).forEach(id => {
        members = [];
        project = action.projects[id];
        const { metadata, clips, ...pData } = project.data;

        if (project.members) {
            project.members.forEach((member) => {
                members.push(project.membermetadata.members[member].email);
            });
            metadata.fields.members = members.join(';');
        }

        newProjects[project.id] = { ...pData, metadata: Object.assign({}, metadata.fields), originalObject: project, created: metadata.fields.created };

    });

    return updateObject(state, {
        projects: newProjects, loading: false
    });
}

const getDeletedUploadProjectsStart = (state, action) => {
    return updateObject(state, { error: null, deletedLoading: true });
}

const getDeletedUploadProjectsSuccess = (state, action) => {
    let newProjects = {};
    Object.keys(action.deletedProjects).forEach(id => {
        let project = action.deletedProjects[id];
        const { metadata, clips, ...pData } = project.data;
        newProjects[project.id] = { ...pData, metadata: metadata, originalObject: project, created: metadata.fields.created };

    });

    return updateObject(state, {
        deletedProjects: newProjects, deletedLoading: false
    });
}

const getUploadProjectSchemesSuccess = (state, action) => {
    return updateObject(state, { uploadProjectSchemes: action.payload, schemesLoading: false });
}

const getUploadProjectSchemesFail = (state, action) => {
    return updateObject(state, { schemesLoading: false, schemesError: action.payload });
}

const getUploadProjectSchemesStart = (state, action) => {
    return updateObject(state, { schemesLoading: true });
}

const uploadProjectDeleted = (state, action) => {
    let delProjects = { ...state.deletedProjects };
    delete (delProjects[action.payload.projectId]);
    return updateObject(state, { deletedProjects: delProjects, deletedLoading: false });
}

const saveNewUploadProject = (state, action) => {
    let maxProjectId = 0;
    for (let project of state) {
        if (project.projectId > maxProjectId) {
            maxProjectId = project.projectId;
            console.log("maxProjectId:" + maxProjectId);
        }
    }
    return state;
}

const setActiveUploadProject = (state, action) => {
    return updateObject(state, { activeProject: action.payload.activeProject });
}

const updateUploadProject = (state, action) => {
    console.log("updating project");
    let members = [];
    let project = action.project;
    const { metadata, clips, ...pData } = project.data;

    project.members.forEach((member) => {
        members.push(project.membermetadata.members[member].email);
    });
    metadata.fields.members = members.join(';');
    let newProject = { ...pData, metadata: Object.assign({}, metadata.fields), originalObject: project };
    return updateObject(state, { projects: updateObject(state.projects, { [project.id]: newProject }) });
}


const reducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.UPLOADPROJECTS_GET_PROJECTS_START: return getUploadProjectsStart(state, action);
        case actionTypes.UPLOADPROJECTS_GET_PROJECTS_SUCCESS: return getUploadProjectsSuccess(state, action);
        case actionTypes.UPLOADPROJECTS_GET_PROJECTS_FAIL: return getUploadProjectsFail(state, action);
        case actionTypes.UPLOADPROJECTS_GET_DELETED_PROJECTS_SUCCESS: return getDeletedUploadProjectsSuccess(state, action);
        case actionTypes.UPLOADPROJECTS_GET_DELETED_PROJECTS_START: return getDeletedUploadProjectsStart(state, action);
        case actionTypes.UPLOADPROJECTS_DELETE_PROJECT_START: return updateObject(state, { deletedLoading: true });
        case actionTypes.UPLOADPROJECTS_DELETE_PROJECT_SUCCESS: return uploadProjectDeleted(state, action);
        case actionTypes.DELETE_PROJECT_FAIL: return updateObject(state, { deletedLoading: false });
        case actionTypes.UPLOADPROJECTS_SAVE_NEW_PROJECT: return saveNewUploadProject(state, action);
        case actionTypes.UPLOADPROJECTS_SET_ACTIVE_PROJECT: return setActiveUploadProject(state, action);
        case actionTypes.UPLOADPROJECTS_PROJECT_UPDATE_RECEIVED: return updateUploadProject(state, action);
        case actionTypes.UPLOADPROJECTS_GET_SCHEMES_START: return getUploadProjectSchemesStart(state, action);
        case actionTypes.UPLOADPROJECTS_GET_SCHEMES_SUCCESS: return getUploadProjectSchemesSuccess(state, action);
        case actionTypes.UPLOADPROJECTS_GET_SCHEMES_FAIL: return getUploadProjectSchemesFail(state, action);
        case actionTypes.UPLOADPROJECTS_SET_CURRENT_UPLOADPROJECT: return updateObject(state, { currentProject: action.payload });
        case actionTypes.UPLOADPROJECTS_SET_LOADING: return updateObject(state, { loading: action.payload.loading })
        default: return state;
    }
}

export default reducer;
